module.exports = "/_next/static/images/ship-line-72bf690361718e43ced88606fb19d15d.svg";